import Strings from './strings';

export default class Localize {
  constructor(lang = 'en_CA') {
    this.lang = lang;
  }

  string(...keys) {
    keys.splice(0, 0, this.lang);
    return keys.reduce((i,k) => i[k], Strings);
  }
}